import {
	PI_SHEETS_FETCH_REQUEST,
	PI_SHEETS_FETCH_FAILURE,
	PI_SHEETS_FETCH_SUCCESS,
	PI_SHEET_FETCH_REQUEST,
	PI_SHEET_FETCH_FAILURE,
	PI_SHEET_FETCH_SUCCESS,
	PI_SHEET_UPDATE_REQUEST,
	PI_SHEET_UPDATE_FAILURE,
	PI_SHEET_UPDATE_SUCCESS,
	PI_SHEET_CREATE_REQUEST,
	PI_SHEET_CREATE_FAILURE,
	PI_SHEET_CREATE_SUCCESS,
	PI_SHEET_DELETE_REQUEST,
	PI_SHEET_DELETE_FAILURE,
	PI_SHEET_DELETE_SUCCESS,
	PI_SHEET_SET,
	PI_SHEET_RESET_MESSAGE,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function PISHeets(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case PI_SHEET_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case PI_SHEET_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case PI_SHEETS_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case PI_SHEETS_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case PI_SHEETS_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
			};

		case PI_SHEET_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case PI_SHEET_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case PI_SHEET_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
				selected: Number(payload.id),
			};

		case PI_SHEET_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PI_SHEET_UPDATE_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PI_SHEET_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case PI_SHEET_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PI_SHEET_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PI_SHEET_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case PI_SHEET_DELETE_REQUEST:
			return {
				...state,
				isDeleting: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PI_SHEET_DELETE_FAILURE:
			return {
				...state,
				isDeleting: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PI_SHEET_DELETE_SUCCESS:
			return {
				...state,
				isDeleting: false,
				message: {
					type: '',
					text: '',
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/PISheets.js